/*
 * @Auther: 罗耀祖
 * @Date: 2021-11-23 16:55:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-19 11:56:40
 * @name: 工单配置
 * @Description: 工单配置信息
 * @FilePath: \project\src\config\issue.config.js
 * @Author: desktop
 */

//是否需要用户寄回
export const need_send_backs = [
  {
    label: "是",
    value: 1,
  },
  {
    label: "否",
    value: 0,
  },
]
//可选的寄回方式
export const send_back_ways = [
  {
    label: "先补后退",
    value: 1,
  },
  {
    label: "先退后补",
    value: 2,
  },
]
//是否需要品质审批
export const need_qa_checks = [
  {
    label: "否",
    value: 0,
  },
  {
    label: "是",
    value: 1,
  },
]
//是否需要费用
export const need_pays = [
  {
    label: "是",
    value: 1,
  },
  {
    label: "否",
    value: 0,
  },
  {
    label: "暂不填写",
    value: 2,
  },
]
//费用收取对象
export const pay_users = [
  {
    label: "经销商",
    value: 1,
  },
  {
    label: "物流公司",
    value: 2,
  },
]
//处理方式
export const resolve_ways = [
  {
    label: "补发/更换配件",
    value: 1,
  },
  {
    label: "上门服务",
    value: 2,
  },
  {
    label: "整琴退换",
    value: 3,
  },
  {
    label: "其他",
    value: 4,
  },
]
// 费用结构
export const origin_fee = [
  {
    key: 'shell_fee',
    parent: 'parts_fee',
    label: '外壳',
    value: 0,
    type: 'fee',
  },
  {
    key: 'code_fee',
    parent: 'parts_fee',
    label: '码克',
    value: 0,
    type: 'fee',
  },
  {
    key: 'prellmechanik_fee',
    parent: 'parts_fee',
    label: '击弦机',
    value: 0,
    type: 'fee',
  },
  {
    key: 'keyboard_fee',
    parent: 'parts_fee',
    label: '键盘',
    value: 0,
    type: 'fee',
  },
  {
    key: 'hardware',
    parent: 'parts_fee',
    label: '五金件',
    value: 0,
    type: 'fee',
  },
  {
    key: 'hammer',
    parent: 'parts_fee',
    label: '榔头',
    value: 0,
    type: 'fee',
  },
  {
    key: 'other',
    parent: 'parts_fee',
    label: '其他',
    value: 0,
    type: 'fee',
  },
  {
    key: 'parts_remark',
    parent: 'parts_fee',
    label: '备注',
    value: '',
    type: 'remark',
  },
  {
    key: 'by_the_piece_fee',
    parent: 'salary',
    label: '计件',
    value: 0,
    type: 'fee',
  },
  {
    key: 'hourly_wages',
    parent: 'salary',
    label: '计时',
    value: 0,
    type: 'fee',
  },
  {
    key: 'oil_paint',
    parent: 'salary',
    label: '油漆',
    value: 0,
    type: 'fee',
  },
  {
    key: 'salary_remark',
    parent: 'salary',
    label: '备注',
    value: '',
    type: 'remark',
  },
  {
    key: 'amount_returned_by_customer',
    parent: 'trans_port',
    label: '客户退回金额',
    value: 0,
    type: 'fee',
  },
  {
    key: 'return_customer_amount',
    parent: 'trans_port',
    label: '返回客户金额',
    value: 0,
    type: 'fee',
  },
  {
    key: 'transport_remark',
    parent: 'trans_port',
    label: '备注',
    value: '',
    type: 'remark',
  },
  {
    key: 'management_expenses',
    parent: 'others',
    label: '管理费',
    value: 0,
    type: 'fee',
  },
  {
    key: 'tax',
    parent: 'others',
    label: '税费',
    value: 0,
    type: 'fee',
  },
  {
    key: 'others_fee',
    parent: 'others',
    label: '其他',
    value: 0,
    type: 'fee',
  },
  {
    key: 'others_remark',
    parent: 'others',
    label: '备注',
    value: '',
    type: 'remark',
  },
]
export default {
  need_send_backs,
  send_back_ways,
  need_qa_checks,
  need_pays,
  resolve_ways,
  origin_fee,
}